import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "@/services/auth";
import { deleteCookie } from "@/lib/cookies";
import axios from "axios";
interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const token = getToken();

  if (!token) {
    if (!location.pathname.includes("callback")) {
      return <Navigate to="/auth" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
